import React from "react";
import Messages from "../../components/dashboard/messages";

const MessagesPage = () => {
  return <Messages />;
};

export default MessagesPage;
